<template>
  <div :class="['documents-card medium-border-radius', type === 'success' && 'offwhite-bg']">
    <div :class="['card-header p-2 text-center mb-2 medium-border-radius', type === 'danger' && 'danger-bg']">
      <h5 class="text-bold" v-if="type === 'success'">DOCUMENTOS ENVIADOS</h5>
      <h5 class="text-bold text-white" v-if="type === 'danger'">DOCUMENTOS NÃO ENVIADOS</h5>
      <p v-if="type === 'success'">Total de {{ docs.length }} documentos enviados</p>
      <p v-if="type === 'danger'" class="text-white">Faltam {{ missingDocs.filter((doc) => doc.status === 'missing').length }} documentos obrigatórios</p>

      <div v-if="type === 'success' && docs.length > 0" class="flex ai-c fgap2 mt-2 bulk-actions">
        <label class="flex ai-c fgap1 select-all-label" style="margin-bottom: 0px;">
          <input
            type="checkbox"
            :checked="allDocsSelected"
            @change="toggleSelectAll"
          />
          <span>Selecionar todos</span>
        </label>
        <button
          type="button"
          class="btn solid primary medium text-thin"
          :disabled="!hasSelection"
          @click.prevent="downloadSelectedZip"
        >
          BAIXAR SELECIONADOS
        </button>
      </div>
    </div>

    <div class="card-content ph-2">
      <ul class="files-list columns gap2" v-if="type === 'success'">
        <li class="flex ai-c jc-sb fgap2 pb-2 span-12" v-for="doc in docs" :key="doc.id">
          <div class="flex ai-c fgap1">
            <input
              type="checkbox"
              class="doc-checkbox"
              :value="doc.id"
              v-model="selectedDocIds"
            />
            <span v-if="verifyDocIcon(doc.originalFilename) === 'pdf'">
              <img src="@/assets/img/pdf.png" width="60px" height="60px" alt="PDF">
            </span>
            <span v-if="verifyDocIcon(doc.originalFilename) === 'xml'">
              <img src="@/assets/img/xml.png" width="60px" height="60px" alt="XML">
            </span>
            <span v-if="verifyDocIcon(doc.originalFilename) === 'png'">
              <img src="@/assets/img/png.png" width="60px" height="60px" alt="PNG">
            </span>
            <span v-if="verifyDocIcon(doc.originalFilename) === 'jpeg'">
              <img src="@/assets/img/jpg.png" width="60px" height="60px" alt="JPEG">
            </span>
            <span v-if="verifyDocIcon(doc.originalFilename) === 'jpg'">
              <img src="@/assets/img/jpg.png" width="60px" height="60px" alt="JPG">
            </span>
            <span v-if="verifyDocIcon(doc.originalFilename) === 'xlsx'">
              <img src="@/assets/img/xls.png" width="60px" height="60px" alt="XLSX">
            </span>
            <span v-if="verifyDocIcon(doc.originalFilename) === 'general'">
              <img src="@/assets/img/archive.png" width="60px" height="60px" alt="ARQUIVO">
            </span>
            <div>
              <p class="text-bold">{{ doc.documentTypeName }}</p>
              <p class="doc-description">{{ doc.originalFilename }}</p>
              <p class="small-info text-sm"> Enviando em {{doc.created | moment("DD/MM/YY à\\s H:MM:ss")}} por {{ doc.createdBy }} </p>
            </div>
          </div>

          <button type="button" @click.prevent="() => downloadDocument(doc.id, doc.originalFilename)" class="btn solid primary medium text-thin">BAIXAR DOCUMENTO</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import { mapActions } from 'vuex';

export default {
  name: 'DocumentsCard',
  data() {
    return {
      selectedDocIds: [],
    };
  },
  computed: {
    allDocsSelected() {
      return this.docs.length > 0 && this.selectedDocIds.length === this.docs.length;
    },
    hasSelection() {
      return this.selectedDocIds.length > 0;
    },
  },
  methods: {
    ...mapActions(['toggleLoading']),
    toggleSelectAll(event) {
      if (event.target.checked) {
        this.selectedDocIds = this.docs.map((doc) => doc.id);
      } else {
        this.selectedDocIds = [];
      }
    },
    triggerBlobDownload(blobData, filename) {
      const url = window.URL.createObjectURL(new Blob([blobData]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    async downloadDocument(docId, originalFilename) {
      try {
        this.toggleLoading(true);
        const response = await api.get(`/api/public/customer/processes/${this.process.id}/documents/${docId}/download`, {
          responseType: 'blob',
        });
        this.triggerBlobDownload(response.data, originalFilename);
      } catch (err) {
        this.$toast.error('Não foi possível fazer o download do arquivo!');
      } finally {
        this.toggleLoading(false);
      }
    },
    async downloadSelectedZip() {
      if (!this.hasSelection) {
        return;
      }

      try {
        this.toggleLoading(true);
        const response = await api.post(
          `/api/public/customer/processes/${this.process.id}/documents/download-zip`,
          { documentIds: this.selectedDocIds },
          { responseType: 'blob' },
        );
        const zipFilename = `documentos-processo-${this.process.identification}.zip`;
        this.triggerBlobDownload(response.data, zipFilename);
        this.$toast.success('Arquivos baixados com sucesso!');
      } catch (err) {
        this.$toast.error('Não foi possível fazer o download dos arquivos selecionados!');
      } finally {
        this.toggleLoading(false);
      }
    },
    verifyDocIcon(originalFilename) {
      const reg = [
        {
          type: 'pdf',
          reg: new RegExp('.pdf', 'gi'),
        },
        {
          type: 'jpeg',
          reg: new RegExp('.jpeg', 'gi'),
        },
        {
          type: 'jpg',
          reg: new RegExp('.jpg', 'gi'),
        },
        {
          type: 'png',
          reg: new RegExp('.png', 'gi'),
        },
        {
          type: 'xml',
          reg: new RegExp('.xml', 'gi'),
        },
        {
          type: 'xlsx',
          reg: new RegExp('.xlsx', 'gi'),
        },
      ];

      let type = 'general';

      reg.forEach((r) => {
        if (r.reg.test(originalFilename)) {
          type = r.type;
        }
      });

      return type;
    },
  },
  props: {
    type: {
      type: String,
      default: 'success',
    },
    docs: {
      type: Array,
      default: () => [],
    },
    missingDocs: {
      type: Array,
      default: () => [],
    },
    process: {
      type: Object,
      default: () => {},
    },
  },
  async mounted() {
    if (this.$route.query.docIdDownload) {
        let doc = this.docs.filter(doc => doc.id == this.$route.query.docIdDownload);
        if(doc.length > 0) {
            await this.downloadDocument(this.$route.query.docIdDownload, doc[0].originalFilename);
            this.$router.replace({ query: {} });
        } else {
            this.$toast.error('O arquivo não foi encontrado para download!');
            this.$router.replace({ query: {} });
        }
    }
  }
};
</script>

<style scoped>
  .files-list:not(.missing) li:not(:last-of-type) {
    border-bottom: var(--input-border);
  }

  .files-list.missing li {
    border-bottom: var(--input-border);
  }

  .doc-description {
    white-space: nowrap;
  }

  .bulk-actions {
    flex-wrap: wrap;
  }

  .select-all-label,
  .select-all-label input[type="checkbox"],
  .doc-checkbox {
    cursor: pointer;
  }

  .doc-checkbox {
    flex-shrink: 0;
  }
</style>
